<template>
    <div class="medel-wall-page">
        <!-- listview -->
        <div class="listView" ref="listView_ref" @scroll="handleScroll">
          <div class="listView-item" v-for="(item,index) in dataGroup" :key="index" v-show="item?.isShow" @click="itemHandle(item)">
            <!-- yuli-图文 -->
            <div class="yuli-view" v-if="item?.isYuli">
                <img
                    class="yuli-view-img"
                    :src="item?.badgeIcon || require('@/assets/images/YuliApp/badgeWall/badgeIcon/yuli.png')"
                />
                <span class="yuli-view-id"
                      :class="{
                        'yuli-view-id-gold': item?.isYuli?.role_type == 6
                      }">
                    #{{ item?.isYuli?.id }}
                </span>
            </div>
            <!-- 普通徽章-处理 -->
            <div v-else>
                <img
                    class="listView-item-iconView-badgeImg"
                    :src="item?.badgeIcon"
                />
            </div>
            <!-- 文本区 -->
            <div class="listView-item-textView">
                <div class="listView-item-textView-label">{{ item?.label }}</div>
                <div class="listView-item-textView-time">{{ getTimeHanlde((item?.time * 1000), 'YYYY-MM-DD') }}</div>
            </div>
            <!-- 红点 -->
            <div class="listView-item-redPoint" v-show="item.isNewBadge"></div>
          </div>
          <!-- 数据缺省 -->
          <div class="listView-nodata" v-show="dataGroup?.length <= 0">
                <img
                    class="listView-nodata-item"
                    :src="require('@/assets/images/YuliApp/badgeWall/robot/nodata-medelwall.png')"
                    v-for="num in 12"
                    :key="num"
                />
                <span>{{ localesPackage?.['badgewall_default2']?.[localesEnv] }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
import _ from "lodash";
import { mapState } from "vuex";
import appBridging from "@/utils/appBridging.js";
import { getTime } from "@/utils/utils";
import { px2rem } from "@//utils/utils.js";

export default {
    components: {},
    props: {
        DataBase: {
            type: Object,
            default: () => {
                return null
            }
        },
        newBadgeFlag: {
            default: false
        }
    },
    computed: {
        ...mapState({
            init: (state) => state.global.init,
            statusBarHeight: (state) => state.global.statusBarHeight,
            languageEnv: (state) => state.global.languageEnv,
            languagePackage: (state) => state.global.languagePackage,
        }),
    },
    watch: {
        DataBase: {
            async handler(value) {
                console.log('DataBase: ',value);
                this.pageInit(value);
            },
            immediate: true,
            deep: true,
        },
        languageEnv: {
            async handler(value) {
                if(value){
                this.localesEnv = value;
                }
            },
            immediate: true,
            deep: true,
        },
        languagePackage: {
            async handler(value) {
                if(value){
                this.localesPackage = value;
                }
            },
            immediate: true,
            deep: true,
        }
    },
    setup(props, { emit }) {
        const { cur_kep, total_kep } = props;
        /**语言包 - ref */
        const localesPackage = ref({});
        /**语言环境 - ref */
        const localesEnv = ref('en');
        const listView_ref = ref(null);
        const dataGroup = ref([]);

        onBeforeMount(()=>{
            appBridging.getStatusBarHeight();
        })
        
        const getTimeHanlde = getTime;

        /**页面数据初始化 */
        const pageInit = async (initData) => {
            const { data, roles, address } = initData;
            // 过滤数据 -> 分类
            const normalBadgeGroup = data?.filter(item => item?.medal_type == 1); // 常规徽章数据组
            const yuliBadgeGroup = data?.filter(item => item?.medal_type == 2); // yuli徽章数据组
            /**最终渲染数组 */
            const endShowResGroup = [];

            // 常规徽章处理
            normalBadgeGroup?.forEach(badgeItem => {
                const { completed_count: parent_completed_count } = badgeItem;
                badgeItem?.children?.forEach(starItem => {
                    const endRes = getCompletedState(starItem);
                    const { nowStar, state, claimed_at, name, icon_url, abstract, score, id: starId } = endRes;
                    if(state == 2){
                        // 已领取
                        endShowResGroup.push({
                            label: name,
                            badgeIcon: icon_url || require('@/assets/images/YuliApp/badgeWall/badgeIcon/yuli.png'),
                            nowStar: nowStar,
                            maxStar: badgeItem?.children?.length || 1,
                            time: claimed_at,
                            isYuli: null,
                            abstract,
                            score,
                            starId
                        })
                    }
                })
            })
            // yuli徽章数据组
            // yuli数据处理(含角色)
            const yuliBadgeMisson = yuliBadgeGroup?.filter(item => item?.condition_id <= 5 || item.scene == 6) || []; // yuli徽章数组 - 限于等级类型关联
            // 转map存储
            const yuliBadgeMap = {}; 
            yuliBadgeMisson.forEach(item => {
                yuliBadgeMap[item.condition_id] = item;
            })
            Object.keys(yuliBadgeMap).forEach(yuliBadgeKeys => {
                // 匹配成功后 - 遍历徽章各个星阶 - 计算完成状态
                const curentBadge = yuliBadgeMap?.[yuliBadgeKeys];
                const group = curentBadge?.children;
                // console.log(group);
                group?.forEach(starItem => {
                    // 去寻找此星阶的完成组中，遍历
                    starItem?.roles?.forEach( yuliItem => {
                        // 只进属于自己的徽章
                        if(address == yuliItem?.address){
                            endShowResGroup.push({
                                label: starItem?.name,
                                badgeIcon: starItem?.icon_url || require('@/assets/images/YuliApp/badgeWall/badgeIcon/yuli.png'),
                                nowStar: starItem?.star,
                                maxStar: group?.length || 1,
                                time: yuliItem?.claimed_at,
                                isYuli: curentBadge.scene !== 6 && {
                                    id: yuliItem?.token_id,
                                    role_type: yuliItem?.role_type,
                                },
                                abstract: starItem.abstract,
                                score: starItem.score,
                                starId: starItem.id,
                                yuliId: yuliItem?.token_id
                            })
                        }
                    } )
                })
            })
            dataGroup.value = dataRenderHandle(dataSortHandle(endShowResGroup));
        }

        /**获取星阶的状态(关联展示)*/
        const getCompletedState = (starItem) => {
            const { is_claimed, star, claimed_at, icon_url, name, reward_value, prop_info, abstract, score } = starItem;
            let res = {
                ...starItem,
                name: name,
                star: star,
                nowStar: star,
                claimed_at: claimed_at,
                icon_url: icon_url,
                abstract,
                score,
            }
            // 最后state判断
            if(is_claimed){
                // 已领取
                return {
                    ...res,
                    state: 2
                }
            }else{
                // 未领取
                return {
                    ...res,
                    state: 0
                }
            }
        }

        /**数据排序 */
        const dataSortHandle = (dataGroup) => {
            // console.log('数据排序-前: ', dataGroup);
            let totalData = {
                score: 0,
                total: 0
            }
            const newBadgeDataGroup = props.newBadgeFlag;
            let resData = dataGroup?.map(item => {
                // 已领取 - 基于特殊情况，按时间排序，
                const { time, score, starId, yuliId } = item;
                let isNewBadge = false;
                if(newBadgeDataGroup && newBadgeDataGroup?.length > 0){
                    // 如果红点标志是数组
                    for(let i = 0; i < newBadgeDataGroup?.length; i++){
                        const currentItem = newBadgeDataGroup[i];
                        if(yuliId && currentItem.yuliId){
                            if(currentItem.starId == starId && currentItem.yuliId == yuliId){
                                isNewBadge = true;
                                break;
                            }
                        }else{
                            if(currentItem.starId == starId){
                                isNewBadge = true;
                                break;
                            }
                        }
                        
                    }
                }
                const currentTime = new Date().getTime(); //获取当前时间戳
                item.priority = (time || 0) - currentTime;
                item.isNewBadge = isNewBadge;
                totalData.score += score;
                totalData.total += 1;
                return item;
            }) || [];
            
            // 按权限从大到小排序
            resData.sort((pre,next) => next.priority - pre.priority);
            resData = resData.map((item, index) => {
                return {
                    ...item,
                    currentDex: resData.length - index
                }
            })
            // console.log('数据排序-后: ', resData);
            // console.log('数据排序-后:', totalData);
            emit('handle', 'medal-total-data', totalData);
            return resData;
        }

        /**
         * 滑动监听处理
         */
        const handleScroll = () => {
            const scrollTop = listView_ref.value.scrollTop;  // 当前滚动高度
            const cardHeightRem = parseFloat(px2rem(190));// 获得高度,单位：rem
            const scrollTopRem = parseInt(px2rem(scrollTop));
            const overCardNumber = scrollTopRem / cardHeightRem;// 计算当前超过卡牌组 一组两张
            dataGroup.value = dataRenderHandle(_.cloneDeep(dataGroup.value), overCardNumber);
        };

        /**数据渲染控制 */
        const dataRenderHandle = (dataGroup, overCardNumber = null) => {
            return dataGroup?.map(item => {
                item.isShow = true;
                return item;
            }) || [];
        }

        /**
         * 获取星图的class
         * @param {*} index 
         * @param {*} maxStar 
         */
        const getStarClass = (index, maxStar) => {
            return {
                'stars-view-center': maxStar == 1 || 
                        (maxStar == 2 ) ||
                        (maxStar == 3 && index == 2) || 
                        (maxStar == 4 ) || 
                        (maxStar == 5 && index == 3),
                [`stars-view-item-${index}`]: true
            }
        }

        const handleClosePage = () => {
            console.log('handleClosePage');
            emit('handle', false);
        }

        const itemHandle = (medalItem) => {
            // 本地取消红点
            if(medalItem.isNewBadge){
                const dataGroupLocal = _.cloneDeep(dataGroup.value);
                let index = -1;
                if(medalItem.yuliId){
                    index = dataGroupLocal?.findIndex(item => {
                        return item.starId == medalItem.starId && item.yuliId == medalItem.yuliId;
                    })
                }else index = dataGroupLocal?.findIndex(item => item.starId == medalItem.starId);
                if(index == -1)return;
                dataGroupLocal[index].isNewBadge = false;
                dataGroup.value = dataGroupLocal;
            }
            emit('handle', 'medal-detail-open', medalItem);
        }

        return {
            getStarClass,
            handleClosePage,
            pageInit,
            handleScroll,
            itemHandle,
            getTimeHanlde,
            dataGroup,
            listView_ref,
            localesPackage,
            localesEnv
        };
    },
};
</script>
  
<style lang="less" scoped>
@topHeight: 60px;
@screenTop: 10px;
.medel-wall-page{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
    left: 0;
    top: 0;
}
.listView{
    margin-top: calc(@topHeight + @screenTop + 29px);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 8px;
    width: 100%;
    height: fit-content;
    max-height: calc(100vh - calc(@topHeight + @screenTop + 100px + 29px));
    box-sizing: border-box;
    overflow: scroll;
    &-item{
        width: 44vw;
        height: 172px;
        overflow: scroll;
        margin-right: auto;
        margin-bottom: 10px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        &-iconView{
            margin-top: 80px;
            width: 100%;
            height: 1px;
            position: relative;
            &-badgeImg{
                width: 100px;
                height: 100px;
            }
        }
        &-textView{
            width: 140px;
            &-label{
                color: #fff5d3;
                font-size: 16px;
                font-weight: 600;
                font-family: "PingFang SC";
                text-align: center;
                line-height: 18px;
                margin-bottom: 4px;
            }
            &-time{
                color: #ffb84d;
                font-size: 12px;
                font-weight: 500;
                font-family: "PingFang SC";
                text-align: center;
                line-height: 14.4px;
            }
        }
        &-redPoint{
            position: absolute;
            top: 20px;
            right: 35px;
            width: 14px;
            height: 14px;
            background: url("~@/assets/images/YuliApp/badgeWall/RewardSignal.png") no-repeat
            top left;
            background-size: 100% 100%;
        }
    }
    &-item:nth-child(2n){
        margin-right: unset;
    }
    &-nodata{
        width: 100%;
        height: calc(100vh * 550/896);
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        position: relative;
        padding: 18px 36px;
        overflow: hidden;
        &-item{
            width: 130px;
            height: 170px;
            margin-right: auto;
            margin-bottom: 20px;
        }
        &-item:nth-child(2n){
            margin-right: unset;
        }
        span{
            width: 280px;
            position: fixed;
            top: 48%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff5d3ff;
            font-size: 16px;
            font-weight: 600;
            font-family: "PingFang SC";
            text-align: center;
            word-break: keep-all;
            line-height: 18px;
        }
    }
}
// yuli情况
.yuli-view{
    position: relative;
    &-id{
        position: absolute;
        bottom: 25%;
        right: 50%;
        transform: translate(50%, 0);
        color: #F2F2F2;
        font-size: 12px;
        font-weight: 500;
        font-family: "PingFang SC";
        text-align: center;
        text-shadow: 0 1px 2px rgba(64, 41, 17, 0.56), 1px 0 2px rgba(64, 41, 17, 0.56), -1px 0 2px rgba(64, 41, 17, 0.56), 0 -1px 2px rgba(64, 41, 17, 0.56);
        &-gold{
            color: #fffde7;
        }
    }
    img{
        width: 100px;
        height: 100px;
    }
}
</style>
  